export default "__VITE_ASSET__HJ4eyWtx__"